'use strict';

angular.module('dwtModule').controller('DwtToBeAuthorizedController', [
  '$scope',
  '$sessionStorage',
  '$state',
  '$stateParams',
  '$log',
  'ViewDwtDetailService',
  '$filter',
  'PaginationSvc',
  '$timeout',
  'fileDownloadSvc',
  'cbpDownloadBlob',
  function (
    $scope,
    $sessionStorage,
    $state,
    $stateParams,
    $log,
    ViewDwtDetailService,
    $filter,
    PaginationSvc,
    $timeout,
    fileDownloadSvc,
    cbpDownloadBlob
  ) {
    $scope.userType = $sessionStorage.usertype;
    $scope.userId = $sessionStorage.userId;
    $scope.groupId = $sessionStorage.groupId;

    $scope.peCLaimsList = [];
    $scope.qrfCLaimsList = [];
    $scope.art4aClaimsList = [];

    $scope.selectedQRFCount = 0;
    $scope.selectedPECount = 0;
    $scope.selectedArt4aCount = 0;

    $scope.selectAllPeClaims = false;
    $scope.selectAllQrfClaims = false;
    $scope.selectAllArt4aClaims = false;

    $scope.modalLeftButton = $filter('translate')('label_confirm');
    $scope.modalRightButton = $filter('translate')('label_cancel');
    $scope.modalHeader = $filter('translate')('label_modalConfirmAction');

    $scope.otherFormToolTip = [
      $filter('translate')('label_ortherFormtooltip1'),
      $filter('translate')('label_ortherFormtooltip2')
    ].map(text => `<div>${text}</div>`).join('<br>');

    $scope.ibFormToolTip = [
      $filter('translate')('label_ibFormtooltip1'),
      $filter('translate')('label_ibFormtooltip2')
    ].map(text => `<div>${text}</div>`).join('<br>');

    $scope.qualificationLetterExplainToolTip = [
      $filter('translate')('label_ortherFormtooltip3'),
    ].map(text => `<div>${text}</div>`).join('<br>');

    $scope.getDwtToBeAuthorizedData = function () {
      if ($scope.eventId) {
        $scope.loading = true;
        ViewDwtDetailService.getDwtToBeAuthorizedData($scope.eventId)
          .then(function (response) {
            $scope.currency = response.data.claimsToBeAuthorized.currency;
            $scope.totalCount = response.data.claimsToBeAuthorized.allClaimsCount;

            $scope.allPeClaims = response.data.claimsToBeAuthorized.peClaims;
            $scope.peCLaimsList = $scope.allPeClaims;
            if ($scope.peCLaimsList) {
              $scope.setPEPage(1);
            }

            let totalQrfList = response.data.claimsToBeAuthorized.qrfClaims;
            if (totalQrfList) {
              $scope.allQrfClaims = totalQrfList.filter(c => c.basedOnArticle4a === false);
              $scope.qrfCLaimsList = $scope.allQrfClaims;
              $scope.setQRFPage(1);

              $scope.allArt4aClaims = totalQrfList.filter(c => c.basedOnArticle4a === true);
              $scope.art4aClaimsList = $scope.allArt4aClaims;
              $scope.setArt4aPage(1);
            }
          },
          function (error) {
            if (error.data.httpStatusCode === 404) {
              $scope.setPEPage(1);
              $scope.setQRFPage(1);
              $scope.setArt4aPage(1);
            }
          }
        );
        $scope.loading = false;
      }
    };

    $scope.getDwtToBeAuthorizedData();

    $scope.setPEPage = function (pageNr) {
      if (pageNr < 1) {
        return;
      }
      $scope.pePager = PaginationSvc.GetPager($scope.peCLaimsList.length, pageNr);
      $scope.peItems = $scope.peCLaimsList.slice(
        $scope.pePager.startIndex,
        $scope.pePager.endIndex + 1
      );
    };

    $scope.setQRFPage = function (pageNr) {
      if (pageNr < 1) {
        return;
      }
      $scope.qrfPager = PaginationSvc.GetPager(
        $scope.qrfCLaimsList.length,
        pageNr
      );
      $scope.qrfItems = $scope.qrfCLaimsList.slice(
        $scope.qrfPager.startIndex,
        $scope.qrfPager.endIndex + 1
      );
    };

    $scope.setArt4aPage = function (pageNr) {
      if (pageNr < 1) {
        return;
      }
      $scope.art4aPager = PaginationSvc.GetPager(
        $scope.art4aClaimsList.length,
        pageNr
      );
      $scope.art4aItems = $scope.art4aClaimsList.slice(
        $scope.art4aPager.startIndex,
        $scope.art4aPager.endIndex + 1
      );
    };

    //function call to check all the PE claims which are in sent to issuer status
    $scope.checkAllPE = function () {
      clearErrors();
      angular.forEach($scope.peCLaimsList, function (peClaim) {
        peClaim.select = $scope.selectAllPeClaims;
        if (peClaim.select === true) {
          $scope.selectedPECount = $scope.peCLaimsList.length;
        } else {
          $scope.selectedPECount = 0;
        }
      });
    };

    //function call to check the particular PE claims which are in sent to issuer status
    $scope.selectPEClaim = function () {
      clearErrors();
      $scope.selectAllPeClaims = false;
      var count = 0;
      angular.forEach($scope.peCLaimsList, function (peClaim) {
        if (peClaim.select === true) {
          count++;
        }
      });
      $scope.selectedPECount = count;
    };

    $scope.checkAllQRF = function () {
      clearErrors();
      angular.forEach($scope.qrfCLaimsList, function (qrfClaim) {
        qrfClaim.select = $scope.selectAllQrfClaims;
        if (qrfClaim.select === true) {
          $scope.selectedQRFCount = $scope.qrfCLaimsList.length;
        } else {
          $scope.selectedQRFCount = 0;
        }
      });
    };

    $scope.selectQRFClaim = function () {
      clearErrors();
      $scope.selectAllQrfClaims = false;
      $scope.selectedQRFCount = $scope.qrfCLaimsList.filter(
        c => c.select
      ).length;
    };

    $scope.checkAllArt4a = function () {
      clearErrors();
      angular.forEach($scope.art4aClaimsList, function (claim) {
        claim.select = $scope.selectAllArt4aClaims;
      });
      $scope.selectedArt4aCount = $scope.art4aClaimsList.filter(
        c => c.select
      ).length;
    };

    $scope.selectArt4aClaim = function () {
      clearErrors();
      $scope.selectAllArt4aClaims = false;
      $scope.selectedArt4aCount = $scope.art4aClaimsList.filter(
        c => c.select
      ).length;
    };


    $scope.submitAllPeClaims = function () {
      clearErrors();
      $scope.authorizeAllFlag = true;
      $scope.selectAllPeClaims = true;
      $scope.modalPEClaim = true;
      $scope.modalBody = $filter('translate')('label_authorizeAllPEModal');
      $scope.checkAllPE();
      $scope.peClaimIdArray = [];
      angular.forEach($scope.peCLaimsList, function (peClaim) {
        $scope.peClaimIdArray.push(peClaim.claimId);
      });
    };

    $scope.submitSelectedPeClaims = function () {
      clearErrors();
      $scope.authorizeAllFlag = false;
      $scope.modalPEClaim = false;

      $scope.peClaimIdArray = [];
      angular.forEach($scope.peCLaimsList, function (peClaim) {
        if (peClaim.select === true) {
          $scope.peClaimIdArray.push(peClaim.claimId);
        }
      });
      if ($scope.peClaimIdArray.length === 0) {
        $scope.peClaimsNotselectedErrorMsg = $filter('translate')('label_claimsNotselected');
      } else {
        $scope.modalPEClaim = true;
        $scope.modalBody = $filter('translate')('label_authorizeSelectedPEModal');
      }
    };

    $scope.submitAllQrfClaims = function () {
      clearErrors();
      $scope.authorizeAllFlag = true;
      $scope.selectAllQrfClaims = true;
      $scope.modalQRFClaim = true;
      $scope.modalBody = $filter('translate')('label_authorizeAllQRFModal');
      $scope.checkAllQRF();
      $scope.qrfClaimIdArray = [];
      angular.forEach($scope.qrfCLaimsList, function (qrfClaim) {
        $scope.qrfClaimIdArray.push(qrfClaim.claimId);
      });
    };

    $scope.submitSelectedQrfClaims = function () {
      clearErrors();
      $scope.authorizeAllFlag = false;
      $scope.modalQRFClaim = false;

      $scope.qrfClaimIdArray = $scope.qrfCLaimsList
        .filter(qrfClaim => qrfClaim.select)
        .map(qrfClaim => qrfClaim.claimId);

      if ($scope.qrfClaimIdArray.length === 0) {
        $scope.qrfClaimsNotselectedErrorMsg = $filter('translate')('label_claimsNotselected');
      } else {
        $scope.modalQRFClaim = true;
        $scope.modalBody = $filter('translate')('label_authorizeSelectedQRFModal');
      }
    };

    $scope.submitAllArt4aClaims = function () {
      clearErrors();
      $scope.authorizeAllFlag = true;
      $scope.selectAllArt4aClaims = true;
      $scope.checkAllArt4a();
      $scope.art4aClaimIdArray = [];
      angular.forEach($scope.art4aClaimsList, function (qrfClaim) {
        $scope.art4aClaimIdArray.push(qrfClaim.claimId);
      });

      $scope.modalBody = $filter('translate')('label_authorizeAllQRFModal');
      $scope.modalArt4aClaim = true;
    };

    $scope.submitSelectedArt4aClaims = function () {
      clearErrors();
      $scope.authorizeAllFlag = false;
      $scope.modalArt4aClaim = false;

      $scope.art4aClaimIdArray = $scope.art4aClaimsList
        .filter(claim => claim.select)
        .map(claim => claim.claimId);

      if ($scope.art4aClaimIdArray.length === 0) {
        $scope.art4aClaimsNotselectedErrorMsg = $filter('translate')('label_claimsNotselected');
      } else {
        $scope.modalBody = $filter('translate')('label_authorizeSelectedQRFModal');
        $scope.modalArt4aClaim = true;
      }
    };

    const doDownload = function (url) {
      $scope.fileloading = true;
      fileDownloadSvc.downloadFile(url).then(
        function (response) {
          cbpDownloadBlob(response.file, response.fileName);
          $scope.fileloading = false;
        },
        function (error) {
          $log.debug(error);
          $scope.fileloading = false;
        }
      );
    };

    $scope.downloadClaimForms = function (formType, formId) {
      const downloadUrl = 'v1/claimforms/' + formId + '/' + formType + '/download';
      doDownload(downloadUrl);
    };

    $scope.downloadQualificationLetter = function (claimId) {
      doDownload(`v2/dwt/dwt-claims/${claimId}/qualification-letter-payloads`);
    };

    //function call to invoke the submit claim service
    $scope.submitClaims = function (claimsIdList, claimTypeVal) {
      let claimsListToSubmit = claimsIdList.map(claimId => ({ claimId }));
      let claimsToSubmit = {
        dwtClaims: claimsListToSubmit,
        dwtEventId: $scope.eventId,
        claimType: claimTypeVal,
        authorizeAll: $scope.authorizeAllFlag,
      };
      if ($scope.eventId) {
        $scope.loading = true;
        ViewDwtDetailService.toBeAuthorizeSubmitClaims(claimsToSubmit)
          .then(function (response) {
            $scope.loading = false;
            $scope.success = true;
            $scope.failure = false;
            $scope.errorMessage = null;
            $scope.message = response.data.message;
            $scope.selectAllQrfClaims = false;
            $scope.selectAllPeClaims = false;
            $scope.selectAllArt4aClaims = false;
            $scope.modalPEClaim = false;
            $scope.modalQRFClaim = false;
            $scope.modalArt4aClaim = false;
            $scope.peClaimIdArray = [];
            $scope.qrfClaimIdArray = [];
            $scope.art4aClaimIdArray = [];
            $scope.selectedQRFCount = 0;
            $scope.selectedArt4aCount = 0;
            $scope.selectedPECount = 0;
            $('#successMsg').modal('show');
            $scope.getDwtToBeAuthorizedData(1);
            $timeout(function () {
              $('#successMsg').modal('hide');
              $('.modal-backdrop').remove();
            }, 2000);
          },
          function (error) {
            $scope.loading = false;
            $scope.success = false;
            $scope.message = null;
            $scope.failure = true;
            $scope.errorMessage = error.data.errors[0].errorMessage;
          }
        );
      }
    };

    //function call on click of delete icon to update modal window
    $scope.deleteModal = function (claimId) {
      $scope.deleteClaimId = claimId;
      $scope.modalDelete = true;
      $scope.modalBody = $filter('translate')('label_modalDeleteBody');
    };

    //function call on click of confirm in modal window  to invoke delete service
    $scope.deleteClaim = function (claimId) {
      $scope.loading = true;
      ViewDwtDetailService.deleteClaim(
        $scope.eventId,
        claimId,
        'secureToken'
      ).then(
        function (response) {
          $scope.loading = false;
          $scope.message = response.data.message;
          $scope.modalDelete = false;
          $('#successMsg').modal('show');
          $timeout(function () {
            $('#successMsg').modal('hide');
            $('.modal-backdrop').remove();
            $scope.peCLaimsList = [];
            $scope.qrfCLaimsList = [];
            $scope.getDwtToBeAuthorizedData();
          }, 2000);
        },
        function (error) {
          $scope.loading = false;
          $scope.error = error.data.errors[0].errorMessage;
        }
      );
    };

    $scope.onClaimSearch = function (ownerName) {
      const search = ownerName.trim().toLowerCase();
      $scope.peClaimsList = $scope.allPeClaims
        .filter(c => !search || c.beneficalOwnerName.trim().toLowerCase().includes(search));
      $scope.setPEPage(1);

      $scope.qrfCLaimsList = $scope.allQrfClaims
        .filter(c => !search ||  c.beneficalOwnerName.trim().toLowerCase().includes(search));
      $scope.setQRFPage(1);

      $scope.art4aClaimsList = $scope.allArt4aClaims
        .filter(c => !search || c.beneficalOwnerName.trim().toLowerCase().includes(search));
      $scope.setArt4aPage(1);
    };

    function clearErrors() {
      $scope.peClaimsNotselectedErrorMsg = '';
      $scope.qrfClaimsNotselectedErrorMsg = '';
      $scope.art4aClaimsNotselectedErrorMsg = '';
    }

  },
]);
